const Documents = () => import(/* webpackChunkName: 'Documents' */ '@/Documents/Index');
const ExportedFiles = () => import(/* webpackChunkName: 'ExportedFiles' */ '@/Documents/exported-files/Index');

export default [
    {
      path: '/documents',
      name: 'documents',
      component: Documents,
      meta: { auth: true },
    },
    {
      path: '/documents/:id',
      name: 'exported-files',
      component: ExportedFiles,
      meta: { auth: false },
    },
];
